import { axios } from '@src/utils/networkRequests';
import { useQuery } from '@tanstack/react-query';

export const useReferralToken = () => {
  const fetchReferralToken = async () => {
    const { data } = await axios.get(`/v3/professional/referral_token`);
    return data;
  };

  const { data, isLoading } = useQuery(['referralToken'], () => fetchReferralToken(), {
    retry: 3,
  });

  return { referralToken: data?.referral_token, isLoading };
};
